import React, {Component} from 'react'

import styled from '@emotion/styled'
import sv from '../styles/marketing'
import {isMobile, isMobileOnly} from 'react-device-detect'
import queryString from 'query-string'

import GistPlayer from '../components/player/GistPlayer'
import {Header} from "../components/Header"
import {Container, StyledMedia} from "../styles/CommonStyler"
import Footer from "../components/Footer"
import GistVideoDetails from "../components/player/GistVideoDetails";
import {getMedia} from "../defaults/resourceLinker";

// STYLE ##########################################################

const VideoContainer = styled(`div`)`
    ${sv.flexColumn};
    ${sv.flexCenter};
`;

const Content = styled(`div`)`
  height: ${props => props.height};
  width: 100%;
  max-width: ${props => props.width};
`;

const Details = styled('div')`
  align-content: start;
  width: 100%;
  max-width: ${props => props.width}px;
`;

// COMPONENT ##########################################################

class Player extends Component {

    state = {
        width: 960,
        height: 540,
        isPortrait: false,
        title: '',
        isVideo: true,
        sourceInfo: null,
        sourceError: '',
    };

    componentDidMount() {
        this.fetchSource();
        this.updateSize();
        window.addEventListener("resize", this.updateSize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateSize);
    }

    fetchSource = () => {
        let uuid = this.props.match.params.uuid;
        if (uuid) {
            getMedia(uuid).then(res => {    // fetch for source based on uuid
                if (res) {
                    this.setState({ sourceInfo: res, title: res.title, isVideo: GistPlayer.isVideo(res) });
                }
            }).catch(error => {
                this.setState({sourceError: error.errorMsg})
            })
        }
    };

    updateSize = () => {
        let isPortrait = window.innerWidth < window.innerHeight;
        if (this.state.isPortrait !== isPortrait) this.setState({isPortrait: isPortrait});

        if (isMobile) {
            this.setState({width: window.innerWidth * .85, height: window.innerHeight * .75})
        } else {
            //force re-render
            this.setState((state) => ({height: state.height }));
        }
    };

    render() {
        const {version} = queryString.parse(this.props.location.search);
        const {sourceInfo, sourceError} = this.state;
        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>
                    <Header pageTitle={this.state.title} />

                    <VideoContainer>
                        <Content width={this.state.width + "px"} height={this.state.isVideo ? (this.state.height + "px") : "auto"}>
                            <GistPlayer
                                videoId={this.props.match.params.uuid}  // UUID
                                version={version}                       // gist algorithm version
                                dat={sourceInfo}
                                key={sourceInfo}
                                errorMessage={sourceError}
                            />
                        </Content>
                        <Details width={this.state.width}>
                            <GistVideoDetails info = {sourceInfo} />
                        </Details>
                    </VideoContainer>

                    <Footer/>

                </Container>
            </StyledMedia>
        )
    }

}

export default Player
